import React from "react";
import { motion } from "framer-motion";

const support = ["/sponsors/Artboard12.png"];

export const SectionSponsors = () => {
  return (
    <section id="support" className="w-full pb-10 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
         {/* Title */}
                {/*   <div className="text-center">
                    <motion.h2
                      className="text-2xl font-black uppercase tracking-wider text-lime-600"
                      initial={{ opacity: 0, y: -15 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                      OFFICIAL
                    </motion.h2>
                    <motion.h3
                      className="text-3xl md:text-5xl font-black text-lime-600 mt-2"
                      initial={{ opacity: 0, y: -15 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
                    >
                      SPONSORS
                    </motion.h3>
                  </div>
 */}
          <div className="mb-10">
            {support.length === 1 ? (
              <div className="flex justify-center items-center py-0 px-2 md:px-4">
                <motion.div
                  className="flex justify-center items-center w-full max-w-5xl"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                >
                  <img
                    src={support[0]}
                    alt="Sponsor 1"
                    className="w-full h-auto object-contain mx-auto"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://via.placeholder.com/400x100?text=Sponsor+Image";
                    }}
                  />
                </motion.div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
